import Model from './Model'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
export default class Offer extends Model {

    resource()
    {
        return 'offers'
    }

    get status_friendly() {
        return get(this.statuses.find(stat => stat.id === this.status), 'text')
    }

    get status_color() {
        return get(this.statuses.find(stat => stat.id === this.status), 'color', 'default')
    }

    get statuses () {
        return [{
            id: 'NEW',
            text: 'Nou',
            color: 'default'
        },{
            id: 'ACTIVE',
            text: 'Activ',
            color: 'default'
        },{
            id: 'OFFERED',
            text: 'Ofertat',
            color: 'primary'
        },{
            id: 'PENDING_CUSTOMER',
            text: 'In Asteptare - Client',
            color: 'warning'
        },{
            id: 'INVOICED',
            text: 'Facturat',
            color: 'success'
        },
        /*{
            id: 'FINALIZED',
            text: 'Finalizat',
            color: 'success'
        }*/
        {
            id: 'CANCELED',
            text: 'Anulat',
            color: 'error'
        }]
    }
    get attachments() {
        return [{
            id: 'offer',
            text: 'Oferta',
            condition: (() => {
                return true
            })
        }, {
            id: 'proforma',
            text: 'Proforma',
            condition: (() => {
                return true
            })
        }, {
            id: 'estimateOfWork',
            text: 'Deviz',
            condition: (() => {
                return !isNil(get(this, 'eow_no'))
            })
        }, {
            id: 'invoice',
            text: 'Factura fiscala',
            condition: (() => {
                return !isNil(get(this, 'invoice'))
            })
        }, {
            id: 'invoiceRecipe',
            text: 'Chitanta factura fiscala',
            condition: (() => {
                return !isNil(get(this, 'invoice.recipe'))
            })
        }];
    }
    get currencies() {
        return ['EUR', 'GBP', 'USD']
    }
    get availableAttachments() {
        return this.attachments.filter((item) => item.condition())
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download/offer`
    }

    get downloadEstimateOfWork() {
        return `${this.endpoint()}/download/estimate-of-work`
    }

    get downloadProformaEndpoint() {
        return `${this.endpoint()}/download/proforma`
    }

    get downloadFiscalInvoiceEndpoint() {
        return `${this.endpoint()}/download/invoice`
    }

    get downloadFiscalInvoiceRecipeEndpoint() {
        return `${this.endpoint()}/download/invoice-recipe`
    }
}
